const { isEmpty, } = require('lodash');

module.exports = {
  fields: ({ userVoices = [], question, displayNameHint } = {}) => {
    const userVoiceOptions = userVoices.map(_ => ({ label: _.name, value: _.id }));
    return {
      userVoiceId: {
        label: 'ユーザーズボイス',
        type: 'select',
        options: userVoiceOptions,
        validations: {
          required: v => !isEmpty(v),
        },
      },
      displayName: {
        label: '表示名',
        type: 'string',
        hint: displayNameHint,
        validations: {
          required: v => !isEmpty(v),
        },
      },
      userVoiceHeader: {
        label: 'ユーザーズボイス見出し',
        type: 'text',
      },
      displayContent: {
        label: '表示内容',
        type: 'text',
        hidden: _ => question?.type === 'imageFile',
        validations: {
          required: v => question?.type === 'imageFile' || !isEmpty(v),
        },
      },
    };
  },
};
